module.exports = __webpack_public_path__ + "img/Group 72.c041a080.svg";